<template>
  <div class="table-row pinned-tab">
    <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
    <div class="report-side-panel">
      <div class="sub-header">
        <!--- <report-header></report-header>-->
        <div class="date-range">
          <!--<VueDatePicker v-model="year" :min-date="min_date" :max-date="max_date" type="year" />-->
          <div class="col position">
            <div class="select-wrapper" :class="yearClassObject">
              <v-select
                :options="years"
                label="year"
                clear-button-icon="false"
                v-model="year"
                @input="setYear"
              ></v-select>
            </div>
          </div>

          <div class="col position">
            <div class="select-wrapper" :class="employeeClassObject">
              <v-select
                :options="employeeData"
                label="EmployeeName"
                clear-button-icon="false"
                v-model="employee"
              ></v-select>
            </div>
          </div>
          <div class="download-button-wrapper">
            <a
              data-v-200367fa
              href
              class="cta-btn release-btn"
              @click.prevent="exportExcel()"
            >Download</a>
          </div>
          <!-- <i class="csv-export button-export" @click.stop="exportExcel()"></i> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueDatePicker } from "@mathieustan/vue-datepicker";
//import VueMonthlyPicker from "vue-monthly-picker"; //https://www.npmjs.com/package/vue-monthly-picker
import _ from "lodash";
import moment from "moment";
export default {
  name: "PersonalOverviewRelation",
  data: () => {
    return {
      error: false,
      masterTableWidth: 0,
      loadMore: true,
      timeout: 0,
      year: new Date().getFullYear()
    };
  },
  components: {
    VueDatePicker
  },
  computed: {
    filter: function() {
      return this.$store.state.qtimeReports.personalOverViewfilter;
    },
    employeeData: function() {
      let employeeData = _.cloneDeep(
        this.$store.state.qtimeReports.internalEmployees
      );
      if (employeeData != null) {
        employeeData.push({ ItemId: 0, EmployeeName: "Choose Employee" });
      }
      return employeeData;
    },
    employee: {
      get: function() {
        return this.employeeData.find(
          x =>
            x.ItemId ===
            this.$store.state.qtimeReports.personalOverViewfilter.EmployeeId
        );
      },
      set: function(value) {
        this.$store.commit("setpPersonalOverViewfilterEmployeeId", value);
      }
    },
    employeeClassObject: function() {
      return { "error-border": this.error };
    },
    yearClassObject: function() {
      return { "error-border": this.error };
    },
    years() {
      const year = new Date().getFullYear();
      let years = Array.from(
        { length: year - 2017 },
        (value, index) => 2018 + index
      );
      return years;
    }
  },
  beforeMount() {
    this.fetchUpdatedReport();
  },
  methods: {
    fetchUpdatedReport: function() {
      this.$store.dispatch("fetchInternalEmployees");
    },
    exportExcel: function() {
      console.log(this.year);
      if (this.employee !== undefined && this.employee.ItemId > 0) {
        this.error = false;
        let filter = _.cloneDeep(this.filter);
        // send request
        this.$store.dispatch("exportPersonalOverview", filter);
      } else {
        this.error = true;
      }
    },
    setYear() {
      this.$store.commit("setPersonalOverviewInYear", this.year);
    }
  },
  updated() {},
  mounted() {},

  destroyed() {},
  watch: {}
};
</script>
<style scoped>
.error-border {
  border: 1px solid red;
}

.table-row {
  padding: 20px 20px 10px 20px;
  background: none;
  border: 1px solid rgba(192, 192, 192, 0.3411764705882353);
  border-radius: 11px;
}

.qtime-activity-view {
  width: 100%;
}

.table-row .position {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.month-year-label {
  margin-bottom: 10px;
}

.download-button-wrapper {
  width: 100%;
  text-align: center;
}

.cta-btn {
  padding: 7px 19px;
  margin: 0 auto;
}


.sub-header .date-range,
.sub-header{
  border-top: none !important;
  border-bottom: none !important;
}

.table-row{
  height: 206px;
}



@media screen and (max-width: 1573px){
  .sub-header .date-range{
      padding-left: 0;
      }
}
</style>